var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-filter-summary"},[(!_vm.items.length)?_c('p',{staticClass:"mb-0 grey--text"},[_vm._v("Без дополнительных фильтров")]):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('p',{key:index,staticClass:"mb-1"},[_c('strong',[_vm._v(_vm._s(item.label)+":")]),_vm._v(" "+_vm._s(item.value)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }